import { LegendsContainer } from "@similarweb/pro-logic-components";
import { LegendGridBox } from "@similarweb/ui-components";
import styled from "styled-components";

export const TrendOverTimeWrapper = styled.div`
    width: 100%;
`;

export const GraphWrapper = styled.div`
    box-sizing: border-box;
    padding: 24px;
    ${LegendsContainer} {
        gap: unset;
    }
`;

export const LegendComponentWrapper = styled.div`
    ${LegendGridBox} {
        margin-right: 16px;
    }
`;

export const WidgetOnOffWrapper = styled.div`
    width: 224px;
    margin: 8px 24px 0 0;
`;

export const LegendValue = styled.div`
    margin-right: 8px;
`;
